/* This file is autogenerated, see readme.md for instructions */
import VisualSvgIcon from '@bloomreach/banana-theme/icons/visual.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const VisualIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <VisualSvgIcon />
    </Icon>
  );
});

VisualIcon.displayName = 'VisualIcon';

export default VisualIcon;
